<template>
    <div class="hireModalWrap">
        <Modal
            v-model="hireModalPop"
            class="hireModal newModal"
            title="租户详情"
            width="60%"
            :footer-hide="true"
            :mask-closable="false"
            :closable="false"
        >
            <div class="closeModalTag" @click="closeModal">
                <Icon type="md-close" />
            </div>
            <Form :model="formData" label-position="left" :label-width="110" style="padding:20px 10px;">
                <Row :gutter="64">
                    <Col span="12">
                        <FormItem label="租户名称:" prop="companyName">
                            <div class="fillVal">
                                {{ formData.companyName || "--" }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="税号:" prop="dutyParagraph">
                            <div class="fillVal">
                                {{ formData.dutyParagraph || "--" }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="本次开通时间:">
                            <div class="fillVal">
                                {{ formData.openDate || "--" }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="本次到期时间:">
                            <div class="fillVal">
                                {{ formData.expireDate || "--" }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="租户类型:">
                            <div class="fillVal">
                                {{ +formData.type === 1 ? "客户" : "经销商" }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="管理员姓名:">
                            <div class="fillVal">
                                {{ formData.administratorName || "--" }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="管理员手机号:">
                            <div class="fillVal">
                                {{ formData.administratorMobile || "--" }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="管理员邮箱:">
                            <div class="fillVal">
                                {{ formData.administratorEmail || "--" }}
                            </div>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <Spin fix v-if="spinLoading"></Spin>
        </Modal>
    </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import moment from "moment";
export default {
    props: {
        hireModalPop: Boolean,
        closeModal: Function,
        curItemDetail: Object,
    },
    computed: {},
    data() {
        return {
            spinLoading: false,
            curId: this.curItemDetail.agencyTenantId,
            formData: {},
        };
    },
    created() {
        this.getDetails();
    },
    methods: {
        getDetails() {
            this.spinLoading = true;
            api.axss("get", `/ocm-admin/tenant/${this.curId}`).then((res) => {
                if (res.code === "00000") {
                    this.formData = res.data;
                    setTimeout(() => {
                        this.spinLoading = false;
                    }, 500);
                }
            });
        },
        reset(key) {
            Object.keys(this[key]).forEach((item) => {
                this[key][item] = "";
            });
        },
    },
    watch: {
        curItemDetail: {
            handler: function(newValue, oldValue) {
                if(newValue !== oldValue) this.$refs.formValidate.resetFields()
                if (newValue.id) this.curId = newValue.agencyTenantId;
            },
            deep: true,
        },
    },
};
</script>

<style lang="less">
.hireModal {
    .fillVal {
        background-color: #f2f2f2;
        padding: 0 10px;
    }
}
</style>
